module.exports = __webpack_public_path__ + "img/portrait-029.f2893b83.jpg";